import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@nextui-org/react';
import { Icon } from '@iconify/react';
import { CtyButton } from '../button/CtyButton';

export const VEHICLE_NOT_AT_CENTER_DISCLAIMER =
  'In order to submit a claim the vehicle MUST be at the repair facility and remain at the repair facility until the repairs are complete. Please come back to cars.claims to submit your claim when the vehicle has returned.';

export const NOT_THE_SERVICER_DISCLAIMER =
  'The claim must be submitted by the repair facility. Please have the servicer come back to cars.claims to submit your claim when your vehicle is at the shop.';
type VehicleNotAtCenterModalProps = Readonly<{
  isOpen: boolean;
  onClose: () => void;
  onStartNewClaim: () => void;
  title?: string;
  message?: string;
}>;

export function VehicleNotAtCenterModal({
  isOpen,
  onClose,
  onStartNewClaim,
  title = 'Vehicle Not At Service Center',
  message = VEHICLE_NOT_AT_CENTER_DISCLAIMER,
}: VehicleNotAtCenterModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      placement="center"
      classNames={{ backdrop: 'bg-black/50' }}
    >
      <ModalContent>
        <ModalHeader className="flex flex-col gap-1 border-b border-default-200">
          <span className="text-base font-semibold text-foreground">{title}</span>
        </ModalHeader>
        <ModalBody className="py-5">
          <div
            className="flex gap-2.5 rounded-lg border border-warning bg-warning/20 dark:bg-warning/15 px-3.5 py-3 text-sm text-foreground"
            role="alert"
          >
            <Icon icon="mdi:alert" className="shrink-0 w-5 h-5 text-warning mt-0.5" aria-hidden />
            <p>{message}</p>
          </div>
        </ModalBody>
        <ModalFooter className="border-t border-default-200 gap-2">
          <CtyButton variant="bordered" className="font-semibold" onPress={onClose}>
            Close
          </CtyButton>
          <CtyButton color="primary" className="font-semibold" onPress={onStartNewClaim}>
            Start New Claim
          </CtyButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
